<template>
  <div :class="[
    type === 'textarea' ? 'el-textarea' : 'el-input',
    inputSize ? 'el-input--' + inputSize : '',
    {
      'is-disabled': inputDisabled,
      'is-exceed': inputExceed,
      'el-input-group': $slots.prepend || $slots.append,
      'el-input-group--append': $slots.append,
      'el-input-group--prepend': $slots.prepend,
      'el-input--prefix': $slots.prefix || prefixIcon,
      'el-input--suffix': $slots.suffix || suffixIcon || clearable || showPassword
    }
    ]"
       @mouseenter="hovering = true"
       @mouseleave="hovering = false"
  >
    <template v-if="type !== 'textarea'">
      <!-- 前置元素 -->
      <div class="el-input-group__prepend" v-if="$slots.prepend">
        <slot name="prepend"></slot>
      </div>
      <input
        :aria-label="label"
        :autocomplete="autoComplete || autocomplete"
        :disabled="inputDisabled"
        :readonly="readonly"
        :tabindex="tabindex"
        :type="showPassword ? (passwordVisible ? 'text': 'password') : type"
        @blur="handleBlur"
        @change="handleChange"
        @compositionend="handleCompositionEnd"
        @compositionstart="handleCompositionStart"
        @compositionupdate="handleCompositionUpdate"
        @focus="handleFocus"
        @input="handleInput"
        @keydown.delete="navigateRemove"
        @keydown.down.stop.prevent="navigateOptions('next')"
        @keydown.enter.stop="nativeEnter"
        @keydown.left="navigateOptionsLeft"
        @keydown.right="navigateOptionsRight"
        @keydown.up.stop.prevent="navigateOptions('prev')"
        @mousedown="mousedownInput"
        class="el-input__inner"
        ref="input"
        v-bind="$attrs"
        v-if="type !== 'textarea'"
      >
      <!-- 前置内容 -->
      <span class="el-input__prefix" v-if="$slots.prefix || prefixIcon">
        <slot name="prefix"></slot>
        <i :class="prefixIcon"
           class="el-input__icon"
           v-if="prefixIcon">
        </i>
      </span>
      <!-- 后置内容 -->
      <span
        class="el-input__suffix"
        v-if="getSuffixVisible()">
        <span class="el-input__suffix-inner">
          <template v-if="!showClear || !showPwdVisible || !isWordLimitVisible">
            <slot name="suffix"></slot>
            <i :class="suffixIcon"
               class="el-input__icon"
               v-if="suffixIcon">
            </i>
          </template>
          <i @click="clear"
             @mousedown.prevent
             class="el-input__icon el-icon-circle-close el-input__clear"
             v-if="showClear"
          ></i>
          <i @click="handlePasswordVisible"
             class="el-input__icon el-icon-view el-input__clear"
             v-if="showPwdVisible"
          ></i>
          <span class="el-input__count" v-if="isWordLimitVisible">
            <span class="el-input__count-inner">
              {{ textLength }}/{{ upperLimit }}
            </span>
          </span>
        </span>
        <i :class="['el-input__validateIcon', validateIcon]"
           class="el-input__icon"
           v-if="validateState">
        </i>
      </span>
      <!-- 后置元素 -->
      <div class="el-input-group__append" v-if="$slots.append">
        <slot name="append"></slot>
      </div>
    </template>
    <textarea
      :aria-label="label"
      :autocomplete="autoComplete || autocomplete"
      :disabled="inputDisabled"
      :readonly="readonly"
      :style="textareaStyle"
      :tabindex="tabindex"
      @blur="handleBlur"
      @change="handleChange"
      @compositionend="handleCompositionEnd"
      @compositionstart="handleCompositionStart"
      @compositionupdate="handleCompositionUpdate"
      @focus="handleFocus"
      @input="handleInput"
      class="el-textarea__inner"
      ref="textarea"
      v-bind="$attrs"
      v-else
    >
    </textarea>
    <span class="el-input__count" v-if="isWordLimitVisible && type === 'textarea'">{{ textLength }}/{{ upperLimit }}</span>
    <OnlineIndex :ancient-value="ancientValue" actions="/portal/word/listWordView" left="7rem" ref="online" top="3rem"></OnlineIndex>
  </div>
</template>

<script>
  import {Input} from 'element-ui';
  import {isKorean} from 'element-ui/src/utils/shared';
  import OnlineIndex from './index.vue';

  export default {
    name: 'inputComent',
    extends: Input,
    components: {
      OnlineIndex
    },
    props: {
      ancientShow: {
        type: Boolean,
        required: true,
        default: () => true
      }
    },
    data() {
      return {
        // 鼠标左键点击光标位置
        mouseIndex: 0,
        // 键盘 left ，right 移动时，光标位置
        keydownIndex: 0,
        endIndex: 0,
        ancientValue: '',
        isDelete: false
      };
    },

    mounted() {
    },

    methods: {
      // 需要合成输入时，isComposing 为true
      handleCompositionStart() {
        this.isComposing = true;
      },
      // 合成输入完成时，isComposing为false
      handleCompositionEnd(event) {
        if (this.isComposing) {
          this.isComposing = false;
          this.handleInput(event);
        }
      },
      handleCompositionUpdate(event) {
        const text = event.target.value;
        const lastCharacter = text[text.length - 1] || '';
        this.isComposing = !isKorean(lastCharacter);
      },
      // 鼠标点击方法，获取光标位置
      mousedownInput(event) {
        this.$emit('input', event.target.value);
        setTimeout(() => {
          this.mouseIndex = event.srcElement.selectionStart
          this.keydownIndex = 0
          this.$refs.online.closePopup()
        }, 0)
      },
      // 键盘左方向键方法，获取光标位置
      navigateOptionsLeft(event) {
        setTimeout(() => {
          this.keydownIndex = event.target.selectionStart
        }, 0)
        this.mouseIndex = 0
      },
      // 键盘右方向键方法，获取光标位置
      navigateOptionsRight(event) {
        setTimeout(() => {
          this.keydownIndex = event.target.selectionStart
        }, 0)
        this.mouseIndex = 0
      },
      navigateOptions(item) {
        this.$refs.online.nextWorld(item)
      },
      nativeEnter() {
        this.$refs.online.enterActive()
      },
      // 删除 事件
      navigateRemove(event) {
        this.isDelete = true
      },
      childrenEvent(e) {
        let getIndex = this.mouseIndex || this.keydownIndex
        let text = this.$refs.input.value
        this.$emit('input', text.slice(0, getIndex) + e.wordCode + text.slice(this.endIndex));
        this.$refs.online.closePopup()
        this.$nextTick(() => {
          this.ancientValue = ''
          this.mouseIndex = this.$refs.input.selectionStart
        })
      },
      handleInput(event) {
        let getIndex = this.mouseIndex || this.keydownIndex
        if (this.isDelete && event.target.value.slice(getIndex, event.target.selectionStart) == '') {
          this.$emit('input', event.target.value);
          this.mouseIndex = event.target.selectionStart
          this.isDelete = false
        }
        if (this.isComposing) return;
        // 当为古壮字输入法，执行以下逻辑
        if (this.ancientShow) {
          getIndex = this.mouseIndex || this.keydownIndex
          // event.target.value = event.target.value.substring(getIndex,event.target.selectionStart).replace(/[^\a-\z\A-\Z]/g, '')
          // 输入内容只能为英文字母
          let j = /[^\a-\z\A-\Z]/g
          if (j.test(event.target.value.slice(getIndex, event.target.selectionStart))) {
            let text = event.target.value
            event.target.value = text.slice(0, getIndex) + text.slice(event.target.selectionStart)
            return
          }
          let getValue = event.target.value.slice(getIndex, event.target.selectionStart)
          this.ancientValue = getValue
          this.endIndex = event.target.selectionStart
          return
        }
        if (event.target.value === this.nativeInputValue) return;
        this.$emit('input', event.target.value);
        this.$nextTick(this.setNativeInputValue);
      },
    },
  };
</script>

<style lang="less" scoped>

</style>
